var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonindots058(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 609.607,
    height: 1172.947,
    viewBox: "0 0 609.607 1172.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8446",
    "data-name": "Group 8446",
    transform: "translate(0.592 -0.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465-2",
    "data-name": "Group 465-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15519",
    "data-name": "Path 15519",
    d: "M549.3,1167.1c16.2,0,27.9-445.1-3.2-497.5-24.6-41.5-137.7-77.2-144.8-70.4l-7.8-109.6S644.1,374.5,570.4,194.9,435.8,17.5,351.2,7.8,58.1,93.1,68.6,265,254.7,488.3,254.7,488.3L244.3,599.2s-148.7,26.4-179.8,62C24,707.7-3.7,1069,26.8,1167.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15520",
    "data-name": "Path 15520",
    d: "M471.5,1121.8H98.3s-38-445.5,199.7-446S471.5,1121.8,471.5,1121.8Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15521",
    "data-name": "Path 15521",
    d: "M297.9,675.8c237.7-.5,173.5,446,173.5,446H98.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15522",
    "data-name": "Path 15522",
    d: "M471.5,1121.8H98.3s-38-445.5,199.7-446S471.5,1121.8,471.5,1121.8Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15523",
    "data-name": "Path 15523",
    d: "M412.1,1043.1H159.5S133.8,754.8,294.7,754.5,412.1,1043.1,412.1,1043.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15524",
    "data-name": "Path 15524",
    d: "M360.1,974.2h-147s-15-191.5,78.6-191.7S360.1,974.2,360.1,974.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15525",
    "data-name": "Path 15525",
    d: "M26.8,1167.1l71.4-45.3L19.5,969.6,118,833.3,63.1,666.9l172,22.4,1.1-87,139,95.2,116-62.8L464,837.2l99.8-78.6-85.2,185,84.8,127.1-92,51.1,77.8,45.3-220.5-45.3-117.5,45.3-56.8-45.3Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15527",
    "data-name": "Path 15527",
    d: "M360.1,974.2l51.9,40.4-54.1,28.5-85.8-68.9-81.9,68.9L160,936.9l55.4-75.6-1.1-108,77.5,29.1,73.5-17.7-6.7,96.4,58.7,71.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15528",
    "data-name": "Path 15528",
    d: "M241.3,863.3l56.3-58.7,49.8,81L262.9,959Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15529",
    "data-name": "Path 15529",
    d: "M332.5,65.4s240,53.8,179.6,193.7S391.4,456.5,315.3,437.7,133.5,387.4,133.6,272.4,225.3,66.6,332.5,65.4Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15531",
    "data-name": "Path 15531",
    d: "M250.5,422l-90.2,15L137.2,307.4,73.6,209.6l95.4-54L235.9,33,373.7,77.6,493.6,63.2,523,194.9l55,99.2L449.6,373.8s-13.3,92.1-17.2,94.4S324.7,440,315.2,437.6s-60.6,50.6-60.6,50.6Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15532",
    "data-name": "Path 15532",
    d: "M401.9,414.6c-1.8,1.1-205-22.9-205-22.9L161,168.6,269.5,76.8,467,120.9l45.1,138.3L447.3,381Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15534",
    "data-name": "Path 15534",
    d: "M109.5,187.1l108.9-122L279.9,47,455.8,67.7l47.4,38.8L563.8,264l-13.3,47.3S444.7,434.6,439.9,435.7s-30.2,28.1-34,27.1-132.7,5.5-132.7,5.5l-20.3-8.6-64-27.4-37.2-31.1L87.1,234.7Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15535",
    "data-name": "Path 15535",
    d: "M401.3,599.2,235.1,689.3l199.1-84.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15537",
    "data-name": "Path 15537",
    d: "M89.6,736.7,19.5,878.3,96,999.6,24.8,1121.8l333,45.3L568.2,984.6,469.7,868.3,349.4,637.1l45.4-18.6,147.6,65.6L476.3,904",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15537-2",
    "data-name": "Path 15537-2",
    d: "M165.6,602.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M219.3,119.2,133.6,103,79.3,322.7l92.8,48.6,27.7,92.3,98-15.8,95.8,41.9,23.9-79.8,100.3-8.3L495.2,296.4,557,163.9l-77.6-5.3L423.7,19,354,95.6,293.9,13,269.6,76.8,202.5,50.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M167.3,616.5l39.5,90.4-93.6,1.9,14.2,89.7L32.6,758.4",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196-2",
    "data-name": "Path 196-2",
    d: "M125.3,974.2l41.5-95.9-39.4-79.9,76.5-54.5-23.7-10.5-84-96L37.1,730.9l111.3,12.9L27.2,804.6l78.6,95.1-91,143.4,48.3,101,48-6.9,6.8,29.9,94.4-45.3,74.2,45.3,142.4-24.8,34,24.8,88.3-56.4-74.8-105.1,94.4-123.7S470,768,470.1,766.7s90.4-57.3,90.4-57.3L421.8,742.7l15.3-78.5,102.7,30.1L373,620.2",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196-3",
    "data-name": "Path 196-3",
    d: "M473,870.6l-30.7,150.3,30.7,46.5-136.4,54.5-80.5-78.7-61.3,78.7-61.2-78.7-35.3,78.7",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196-4",
    "data-name": "Path 196-4",
    d: "M256.1,726l75.2-46.7,40.7,75,49.8,2.3,20.1,171.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M244.3,747.7l-4-29.7-33.2,19.5Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15528-2",
    "data-name": "Path 15528-2",
    d: "M281.5,859.3l38.2-2.8-8.1,44-52.6-.9Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15519-2",
    "data-name": "Path 15519-2",
    d: "M549.3,1167.1c16.2,0,27.9-445.1-3.2-497.5-24.6-41.5-137.7-77.2-144.8-70.4l-7.8-109.6S644.1,374.5,570.4,194.9,435.8,17.5,351.2,7.8,58.1,93.1,68.6,265,254.7,488.3,254.7,488.3L244.3,599.2s-148.7,26.4-179.8,62C24,707.7-3.7,1069,26.8,1167.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15520-2",
    "data-name": "Path 15520-2",
    d: "M481.5,1121.8H108.3s-38-445.5,199.7-446S481.5,1121.8,481.5,1121.8Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15521-2",
    "data-name": "Path 15521-2",
    d: "M307.9,675.8c237.7-.5,173.5,446,173.5,446H108.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15522-2",
    "data-name": "Path 15522-2",
    d: "M481.5,1121.8H108.3s-38-445.5,199.7-446S481.5,1121.8,481.5,1121.8Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15523-2",
    "data-name": "Path 15523-2",
    d: "M169.5,1043.1S143.8,754.8,304.7,754.5s117.5,288.6,117.5,288.6",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15524-2",
    "data-name": "Path 15524-2",
    d: "M370.1,974.2h-147s-15-191.5,78.6-191.7S370.1,974.2,370.1,974.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15525-2",
    "data-name": "Path 15525-2",
    d: "M36.8,1167.1l71.4-45.3L29.5,969.6,128,833.3,73.1,666.9l172,22.4,1.1-87,139,95.2,116-62.8L474,837.2l99.8-78.6-85.2,185,84.8,127.1-92,51.1,77.8,45.3-220.5-45.3-117.5,45.3-56.8-45.3Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15526-2",
    "data-name": "Path 15526-2",
    d: "M422.9,871.2l63.5,124.4-64.2,47.5,59.4,78.7-165.1-78.7-51.6,78.7-47.4-78.7-52.8,78.7-58-75.1,63-3.6L112.3,927.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15526-2-2",
    "data-name": "Path 15526-2-2",
    d: "M206.5,780.8l14.9-77.3L327,756.8l108.4-5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15527-2",
    "data-name": "Path 15527-2",
    d: "M370.1,974.2l51.9,40.4-54.1,28.5-85.8-68.9-81.9,68.9L170,936.9l55.4-75.6-1.1-108,77.5,29.1,73.5-17.7-6.7,96.4,58.7,71.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15528-2-2",
    "data-name": "Path 15528-2-2",
    d: "M251.3,863.3l56.3-58.7,49.8,81L272.9,959Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15529-2",
    "data-name": "Path 15529-2",
    d: "M322.5,65.4s240,53.8,179.6,193.7S381.4,456.5,305.3,437.7,123.5,387.4,123.6,272.4,215.3,66.6,322.5,65.4Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15531-2",
    "data-name": "Path 15531-2",
    d: "M240.5,422l-90.2,15L127.2,307.4,63.6,209.6l95.4-54L225.9,33,363.7,77.6,483.6,63.2,513,194.9l55,99.2L439.6,373.8s-13.3,92.1-17.2,94.4S314.7,440,305.2,437.6s-60.6,50.6-60.6,50.6Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15534-2",
    "data-name": "Path 15534-2",
    d: "M99.5,187.1l108.9-122L269.9,47,445.8,67.7l47.4,38.8L553.8,264l-13.3,47.3S434.7,434.6,429.9,435.7s-30.2,28.1-34,27.1-132.7,5.5-132.7,5.5l-20.3-8.6-64-27.4-37.2-31.1L77.1,234.7Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15535-2",
    "data-name": "Path 15535-2",
    d: "M217.1,606.8l28,82.5,253.4-63.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15537-2-2",
    "data-name": "Path 15537-2-2",
    d: "M99.6,736.7,29.5,878.3,106,999.6,34.8,1121.8l333,45.3L578.2,984.6,479.7,868.3,359.4,637.1l45.4-18.6,147.6,65.6L486.3,904",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15537-2-3",
    "data-name": "Path 15537-2-3",
    d: "M155.6,602.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195-2",
    "data-name": "Path 195-2",
    d: "M209.3,119.2,123.6,103,69.3,322.7l92.8,48.6,27.7,92.3,98-15.8,95.8,41.9,23.9-79.8,100.3-8.3L485.2,296.4,547,163.9l-77.6-5.3L413.7,19,344,95.6,283.9,13,259.6,76.8,192.5,50.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197-2",
    "data-name": "Path 197-2",
    d: "M254.3,747.7l-4-29.7-33.2,19.5Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15528-2-3",
    "data-name": "Path 15528-2-3",
    d: "M291.5,859.3l38.2-2.8-8.1,44-52.6-.9Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15519-4",
    "data-name": "Path 15519-4",
    d: "M554.3,1167.1c16.2,0,27.9-445.1-3.2-497.5-24.6-41.5-137.7-77.2-144.8-70.4l-7.8-109.6S649.1,374.5,575.4,194.9,440.8,17.5,356.2,7.8,63.1,93.1,73.6,265,259.7,488.3,259.7,488.3L249.3,599.2s-148.7,26.4-179.8,62C29,707.7,1.3,1069,31.8,1167.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15521-4",
    "data-name": "Path 15521-4",
    d: "M307.9,675.8c237.7-.5,173.5,446,173.5,446H108.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15522-4",
    "data-name": "Path 15522-4",
    d: "M307.9,675.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15522-4-2",
    "data-name": "Path 15522-4-2",
    d: "M481.5,1121.8H108.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15523-4",
    "data-name": "Path 15523-4",
    d: "M169.5,1043.1",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15523-4-2",
    "data-name": "Path 15523-4-2",
    d: "M422.1,1043.1",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15523-4-2-2",
    "data-name": "Path 15523-4-2-2",
    d: "M304.6,754.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15524-4",
    "data-name": "Path 15524-4",
    d: "M223.1,974.2",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15524-4-2",
    "data-name": "Path 15524-4-2",
    d: "M301.7,782.4c93.6-.2,68.3,191.7,68.3,191.7",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15525-4",
    "data-name": "Path 15525-4",
    d: "M128,833.3,73.1,666.9l172,22.4,1.1-87,139,95.2,116-62.8L474,837.2l99.8-78.6-85.2,185,84.8,127.1-92,51.1,77.8,45.3-220.5-45.3-117.5,45.3-56.8-45.3L36.7,1167.1l71.4-45.3L29.5,969.6",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15526-4-2",
    "data-name": "Path 15526-4-2",
    d: "M316.4,1043.1l-51.6,78.7-47.4-78.7-52.8,78.7-58-75.1,63-3.6L112.3,927.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15527-4",
    "data-name": "Path 15527-4",
    d: "M301.7,782.4l73.5-17.7-6.7,96.4,58.7,71.1L370,974.1l51.9,40.4L367.8,1043,282,974.1,200.1,1043,170,936.9l55.4-75.6-1.1-108",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15528-4",
    "data-name": "Path 15528-4",
    d: "M251.3,863.3l56.3-58.7,49.8,81L272.9,959Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15529-4",
    "data-name": "Path 15529-4",
    d: "M322.5,65.4s240,53.8,179.6,193.7S381.4,456.5,305.3,437.7,123.5,387.4,123.6,272.4,215.3,66.6,322.5,65.4Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15531-4",
    "data-name": "Path 15531-4",
    d: "M240.5,422l-90.2,15L127.2,307.4,63.6,209.6l95.4-54L225.9,33,363.7,77.6,483.6,63.2,513,194.9l55,99.2L439.6,373.8s-13.3,92.1-17.2,94.4S314.7,440,305.2,437.6s-60.6,50.6-60.6,50.6Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15534-4",
    "data-name": "Path 15534-4",
    d: "M99.5,187.1l108.9-122L269.9,47,445.8,67.7l47.4,38.8L553.8,264l-13.3,47.3S434.7,434.6,429.9,435.7s-30.2,28.1-34,27.1-132.7,5.5-132.7,5.5l-20.3-8.6-64-27.4-37.2-31.1L77.1,234.7Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15535-4",
    "data-name": "Path 15535-4",
    d: "M254.3,599.2l-9.2,90.1,228.7-75.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15537-4",
    "data-name": "Path 15537-4",
    d: "M397.3,606.8l7.5,11.8L559,675.8,486.3,904",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15537-4-2",
    "data-name": "Path 15537-4-2",
    d: "M226,625.9,99.6,757.7l-70,120.6L106,999.6,34.8,1121.8l333,45.3L578.2,984.6,479.7,847.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195-4",
    "data-name": "Path 195-4",
    d: "M209.3,119.2,123.6,103,69.3,322.7l92.8,48.6,27.7,92.3,98-15.8,95.8,41.9,23.9-79.8,100.3-8.3L485.2,296.4,547,163.9l-77.6-5.3L413.7,19,344,95.6,283.9,13,259.6,76.8,192.5,50.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197-4",
    "data-name": "Path 197-4",
    d: "M254.3,747.7l-4-29.7-33.2,19.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15528-2-5",
    "data-name": "Path 15528-2-5",
    d: "M291.5,859.3l38.2-2.8-8.1,44-52.6-.9Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M172.7,406.8c-8.4-1.2-74.8-25.5-76.4-27.9s12-63.6,11-66.3-43.6-54.9-43.6-54.9,68.9-46.6,69.7-49-37.7-72.1-37.7-72.1l88.6-27.3s-20.1-40.9-15.9-43.8,62.8,24.1,62.8,24.1l17.7-65.9L315.5,62l42.9-49,39.5,60.5L443.3,33l3.1,68.2,51.4,17.3,27.5,2.6L568,233.7l-56.2,17.7,35.1,46.3s-56.7-14-54.7-10,54.7,64.1,54.7,64.1l-70,32.7-15.2-24.3.6,81",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M526.8,672.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201-2",
    "data-name": "Path 201-2",
    d: "M419,679.3l73.6,19.4s-60.8,67.3-48,66.1,125.6-21,125.6-21l-93.5,97.6,70.7,46.9,27.3-57.7L496.8,959l64.3,8.6-64.3,52.7L483,1054.6l91.6-137s8.8-109.8-.8-110.4-117.9-3.7-117.9-3.7",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M278.1,13S42.4,15.8,66.8,314.7",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M573.8,267.6S602.8,58.4,402.1,13",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M125.7,1157.7c-1.3-6-106.4-68-103.3-70.1s74.7-50,74.7-50l-74.8-94s103.2-58.9,97.6-60.4-86.1-41.4-86.1-41.4l91.9-87.2L56.3,705l84.6-22.6L97.1,830.7,47.4,882.4l37.8,53.2L106,959,81.6,991.6l-23.3-39-11,83L29.5,996.2l52.1,102.4,26.7-34-26.7-248,37.7,14.1,36-103.9L106,705l37.6-67.5,44.7,65.2-26,9.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M407.4,654.8s86.1,37.1,86.5,34.6S419.4,715,417,718.1s127.2-24.8,127.2-24.8c-124.6,84.9,25.8,38.4-92.3,65.8,6.5-1.5,74.2,0,74.2,0s47.8,45.4,40.9,45.5-73,16.7-65.8,17.9,60,13,60,13l-52.4,17.6s47.9,7.1,47.1,8.5-37.2,16.8-37.2,16.8l49,15-31.3,17.1s19.4,4,16.1,8.4-30.3,19.6-30.3,19.6l-21-10.8-10.9-38.2L501.2,974l51.2-7.7s-56.4,39.2-53.8,39.2,68.3,15,68.3,15l-44.9,39-23.5,17,23.5,17-23.5,11,33.2,17.2,29.3,22.8H481.4l19.7-22.8,41.2-19.2-1-48-32.6-29.8,43.7-39.2-51.2-96-19.3-70,26.9-37.1-28.6-15.8,67.3-15.8L522.1,665l-94.9,37.6-19.9-74Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M572.8,279.6s22.5-34.1,15.5-42.1-20.3-42-20.3-42,16.3-21.4,16.3-31.7S547,125.6,547,125.6l6.9-32s-22.5-1.5-28.1-8,.5-42-7.5-44-39.7,0-39.7,0-9.3-18-12.3-19-49.2,5.1-49.2,5.1.4-11.2-9.7-14.7-49.1,0-49.1,0L288.9,1.6,263.4,18.7l-47.7,6.9L186.5,47,151,37.6l-26,48-30.6,8-9,47-34,23.2,6,39.7s-23,23-20,23.5,21.2,38,21.2,38L48.3,309.6l37,54",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M575.3,251.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M383.5,489.6s360.3-46.5,167-380.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M453.8,447.4l104.4-40,2.5-73.9,44.6-80.3-29.5-39.1-50-128.5-30.3-8.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200-2",
    "data-name": "Path 200-2",
    d: "M245.7,488.3s-127.3-2-183.4-134.7S90.1,100.5,90.1,100.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15524-2-2",
    "data-name": "Path 15524",
    d: "M287.9,83.1l-24.6,63,61.3-54.8,42.3,40.2-29.1,21.9h64.3l5.1-43.6,29.2,54.1,21.7,38.3L445,253.3l21.3,8.8h22.4l-19.3-35,11.7-32.5-27.3-54.3,3.2-19.4,15.6,193.8L424.1,357l-16.7,52.9L376,374.1l-9.1,35.8-61.6,27.8,40.9-45.3-49.8-23.2,19.5,30.5L240.5,422l-15.4-58.4-9.4-21.2-44.1-27.7-42.4-52.6,32.9,109.2,40.1-56.6-46.6-52.6,30.9-42.8-53.1-10.7L186.5,190l-2.1-49.7,31.3,32.6,24.4-64.1Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15525-2-2",
    "data-name": "Path 15525",
    d: "M60,730.9l-4.4,27.5L13.7,780.8l10-33.1,26.5,56.9L3.7,841.9l43.2-.2L21.7,878.3,37.8,916,11.7,974.2l28,130.1",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15526",
    "data-name": "Path 15526",
    d: "M564.8,893.4l-6.5,74.2,34.1,42.6L577.9,959l28.9-55v70.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15527-2-2",
    "data-name": "Path 15527",
    d: "M156.6,65.4,181,13l38.6,9.6V47l29.2-21.4Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15528-2-2",
    "data-name": "Path 15528",
    d: "M237.8,488.3s-127.3-2-183.4-134.7S82.2,100.5,82.2,100.5L19,108.8l24.4,55L1.6,227.1l20.7,18.6-7.7,21.9L19,333l36.7,58.1,78.1,10L78.6,448l42.7,33.3L189,414.7",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15529-2-2",
    "data-name": "Path 15529",
    d: "M363.187,599.2l71.013,5.3-6.671-18H383.5l38.6-28.793H383.5l-46.092-47.722L407.3,539.234l-23.8-29.249-62.55-27.71L269,505.366l-66.3-7.7,88.95-15.394,24.75,24.631",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15530",
    "data-name": "Path 15530",
    d: "M42.976,65.4,96.07,76.8,119.7,33,53.461,91.264,13.836,62.132,151,37.6V13L63.7,33,42.976,128.21,22.3,157.458,19.5,382.213,55.7,391.1,42.976,463.8,69.3,422.238,144.338,488.2",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15531-2-2",
    "data-name": "Path 15531",
    d: "M22.3,707.5l20.677-34.7L3.7,896.5Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15532-2",
    "data-name": "Path 15532",
    d: "M453.8,282.151h25.6L441.9,314.7l-2.3,59.1",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15533",
    "data-name": "Path 15533",
    d: "M487.5,13,547,65.4l6.9,28.2,35.066,26.912H567.7l21.95,27.709L605.3,194.4,588.966,382.213,563.8,431.475l-17.4-36.946L529.55,447.4,473,414.637l22.5,59.941L578.284,437.7",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonindots058);
export default __webpack_public_path__ + "static/media/personindots-058.97cd0026f0edcb8a2c451d2c209dd1ca.svg";
export { ForwardRef as ReactComponent };